import FooterUsStyle from 'app/components/FooterUsStyle';

import { REPUBS } from '@cx-modules/constants';
import { type Repub } from '@cx-modules/types';

import { FooterNav } from '~/components/FooterNav';
import FooterOC from '~/components/FooterOC';
import { plusLinks } from '~/components/OddscheckerPlus/components/Header';

import styles from './styles/Footer.module.css';

export default function Footer({
  footerData,
  isLandingPage,
  isTipstersEnabled,
  repub,
  resourcesUrl






}: {footerData: any;isLandingPage: boolean;isTipstersEnabled: boolean;repub: Repub;resourcesUrl: string;}) {
  return (
    <footer className={styles.footer} id="mainAppFooter">
			{!isLandingPage && repub !== REPUBS.OC.name &&
      <FooterNav categoryLinks={footerData.categoryLinks} repub={repub} />
      }
			{repub === REPUBS.OC.name ?
      <FooterOC /> :

      <FooterUsStyle
        generalLinks={footerData.generalLinks}
        repub={repub}
        resourcesUrl={resourcesUrl}
        socialLinks={footerData.socialLinks}>

					{isLandingPage &&
        <nav className={styles.plusFooterWrapper}>
							<ul className={styles.plusFooter}>
								{plusLinks({ repub, isTipstersEnabled }).map((item, index) =>
            <li key={`plus-link-${index}`}>
										<a href={item.href}>{item.link}</a>
									</li>
            )}
							</ul>
						</nav>
        }
				</FooterUsStyle>
      }
		</footer>);

}